module.exports = __webpack_public_path__ + "img/planche-logos.c3e34e9.png";